import React from "react";
import { Link } from "react-router-dom";
import plasticscrap from "../Images/plasticscrap.png";
import FAQ from "./FAQ.jsx";
import SEO from "../Components/SEO";

const PlasticScrap = () => {
  return (
    <>
      <SEO 
        title="Industrial Plastic Scrap Recycling" 
        description="Sustainable bulk industrial plastic scrap recycling for HDPE, LDPE, PVC, and engineering plastics."
        keywords="plastic scrap recycling, industrial plastic scrap, recycle HDPE LDPE, PVC scrap recycling"
      />
      <style>{`
        *{
          margin:0;
          padding:0;
          box-sizing:border-box;
          font-family:Arial, Helvetica, sans-serif;
        }

        .hero{
          background:#fff;
          padding:80px 8%;
        }

        .container{
          max-width:1300px;
          margin:auto;
          display:flex;
          align-items:center;
          justify-content:space-between;
          gap:60px;
          flex-wrap:wrap;
        }

        .left{
          flex:1;
          min-width:320px;
        }

        .tag{
          display:inline-block;
          padding:8px 18px;
          background:#FFF5D6;
          color:#0A2E73;
          font-weight:600;
          border-radius:30px;
          margin-bottom:20px;
        }

        .left h1{
          font-size:52px;
          color:#0A2E73;
          line-height:1.2;
          margin-bottom:20px;
        }

        .left h2{
          font-size:30px;
          color:#0A2E73;
          margin:35px 0 15px;
        }

        .left p{
          font-size:17px;
          color:#555;
          line-height:1.9;
          margin-bottom:15px;
        }

        .btn{
          display:inline-block;
          margin-top:25px;
          padding:15px 35px;
          background:#0A2E73;
          color:#FFD700;
          text-decoration:none;
          border-radius:40px;
          font-weight:bold;
          transition:.3s ease;
        }

        .btn:hover{
          background:#FFD700;
          color:#0A2E73;
        }

        .right{
          flex:1;
          min-width:320px;
          transform: translateY(-100px); 
        }

        .right img{
          width:100%;
          margin-bottom:32px;
          height:400px;
          border-radius:20px;
          box-shadow:0 15px 35px rgba(0,0,0,.15);
        }

        @media(max-width:992px){
          .container{
            flex-direction:column-reverse;
            text-align:center;
          }

          .left h1{
            font-size:42px;
          }

          .left h2{
            font-size:28px;
          }
        }

        @media(max-width:768px){

          .hero{
            padding:60px 5%;
          }

          .left h1{
            font-size:34px;
          }

          .left h2{
            font-size:24px;
          }

          .left p{
            font-size:16px;
          }

          .btn{
            padding:14px 28px;
          }

        }

        @media(max-width:480px){

          .left h1{
            font-size:28px;
          }

          .left h2{
            font-size:22px;
          }

          .left p{
            font-size:15px;
          }

        }

      `}</style>

      <section className="hero">

        <div className="container">

          <div className="left">

            <span className="tag">
              Plastic Scrap Dealer
            </span>

            <h1>
              Buy & Sell Premium Quality Plastic Scrap
            </h1>

            <p>
              We deal in all types of plastic scrap including PET bottles,
              HDPE, LDPE, PVC, PP, ABS, plastic drums, containers, industrial
              plastic waste, and recyclable plastic materials. We offer
              competitive prices, quick pickup, and eco-friendly recycling
              solutions.
            </p>

            <h2>
              About Plastic Scrap
            </h2>

            <p>
              Plastic scrap is one of the most important recyclable materials
              used in manufacturing new plastic products. Our company purchases
              and supplies high-quality plastic scrap from industries,
              warehouses, factories, commercial establishments, and recycling
              units.
            </p>

            <p>
              We are committed to sustainable waste management by collecting,
              sorting, and recycling plastic scrap responsibly. Our experienced
              team ensures transparent pricing, accurate weighing, and prompt
              service for every customer.
            </p>

            <Link to="/contact" className="btn">
              Contact Us
            </Link>

          </div>

          <div className="right">

            <img
              src={plasticscrap}
              alt="Plastic Scrap Dealer"
              loading="lazy"
            />

          </div>

        </div>

      </section>
        <FAQ/>

    </>
  );
};

export default PlasticScrap;